import React, { Component } from 'react';
import PropTypes from 'prop-types';

class VxBasicInputField extends Component {
	static propTypes = {
		input: PropTypes.object,
		label: PropTypes.string,
		meta: PropTypes.object,
		id: PropTypes.string,
		validateOnBlur: PropTypes.bool,
		readOnly: PropTypes.bool,
		helpText: PropTypes.string,
		type: PropTypes.string
	}

	render() {
		const {
			input,
			label,
			meta: { touched, error, active },
			id,
			validateOnBlur,
			readOnly,
			helpText
		} = this.props;

		let hasError = validateOnBlur ? !active && touched && error : touched && error;
		const hasValue = !!input.value;
		const type = this.props.type || 'text';
		
		return (
			<div
				className={`vx_input_field vx_floatingLabel_active ${hasError ? 'vx_has-error-with-message' : ''} ${hasValue ? 'hasValue' : ''}`}
				data-label-content={label}
			>
				<label htmlFor={id}>{label}</label>
				<input
					className="form-control vx_form-control"
					type = {type}
					{...input}
					id={id}
					readOnly={readOnly}
				/>

				{
					hasError && <span className="vx_form-control-message" id="help-text">{error}</span>
				}
				{!hasError && helpText &&
					<span className="help-note-desktop">{helpText}</span>
				}
			</div>
		);
	}
}
export default VxBasicInputField;



// WEBPACK FOOTER //
// ./buttons/components/vxFields/VxBasicInputField.js